module.exports = __webpack_public_path__ + "static/media/liquid_22_detail_09.597c2875.jpg";